var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.9 0 6 .9 6 2v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4.8c0-.5-.2-1-.6-1.4L14.6.6c-.4-.4-.9-.6-1.4-.6H8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2v12c0 1.1.9 2 2 2h8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6z"
  })));
};
export default SvgCopy;